if (!window.ProductFormPrice) {
  window.ProductFormPrice = (function () {
    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(window.Shopify?.locale || 'en', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
        }).format(cents / 100);
      } catch (error) {
        return '';
      }
    }

    function update(productInfo) {
      const button = productInfo.querySelector('.product-form__submit[data-unit-price]');
      if (!button) return;

      const priceEl = button.querySelector('[data-product-form-price]');
      if (!priceEl) return;

      if (button.hasAttribute('disabled')) {
        priceEl.textContent = '';
        return;
      }

      const quantityInput = productInfo.querySelector('.quantity__input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      const unitPrice = parseInt(button.dataset.unitPrice, 10) || 0;

      priceEl.textContent = `• ${formatMoney(unitPrice * quantity)}`;
    }

    function init(productInfo) {
      update(productInfo);

      productInfo.addEventListener('change', (event) => {
        if (event.target.classList && event.target.classList.contains('quantity__input')) {
          update(productInfo);
        }
      });

      if (window.subscribe && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== productInfo.dataset.section) return;

          const button = productInfo.querySelector('.product-form__submit[data-unit-price]');
          if (button && data.variant) {
            button.dataset.unitPrice = data.variant.price;
          }

          update(productInfo);
        });
      }
    }

    document.querySelectorAll('product-info').forEach(init);

    return { init, update };
  })();
}
